import { request } from "/src/utils/index.js";

export function Search(params) {
  return request.get("tcm/prescription/list", { params });
}

export function Detail(params) {
  return request.get("tcm/prescription/ai/list", { params });
}

export function Add(params) {
  return request.post("tcm/prescription/ai", params);
}

export function Update(params) {
  return request.put("tcm/prescription", params);
}

export function Delete(data) {
  return request.delete("tcm/prescription/ai", { data });
}
